import request from "@/config/utils/request";
//应用设置：设置分类和等级接口状态查询
export function queryBaseData(data) {
  return request({
    url: "/apis/demo/activate/applyActivate/queryBaseData",
    method: "post",
    data
  });
}

//应用设置：设置分类和等级接口
export function setBaseData(data) {
  return request({
    url: "/apis/demo/activate/applyActivate/setBaseData",
    method: "post",
    data
  });
}

// 查询供应商等级列表
export function supplierGradeList(data) {
  return request({
    url: "/apis/demo/supplierGrade/supplierGradeList",
    method: "post",
    data
  });
}
// 基础数据添加供应商分类
export function saveSupplierClassifyNew(data) {
  return request({
    url: "/apis/demo/supplierClassifyNew/saveSupplierClassifyNew",
    method: "post",
    data
  });
}

// 基础数据查询供应商分类列表
export function qrySupplierClassifyNewList(data) {
  return request({
    url: "/apis/demo/supplierClassifyNew/qrySupplierClassifyNewList",
    method: "post",
    data
  });
}

// 显示选中的资质文件
export function qryAptitudeRequire(data) {
  return request({
    url: "/apis/demo/aptitudeFile/qryAptitudeRequire",
    method: "post",
    data
  });
}

// 维护资质文件
export function qryAptitudeFile(data) {
  return request({
    url: "/apis/demo/aptitudeFile/qryAptitudeFile",
    method: "post",
    data
  });
}

// 供应商类资质文件树
export function qrySupplierClassifyTree(data) {
  return request({
    url: "/apis/demo/aptitudeFile/qrySupplierClassifyTree",
    method: "post",
    data
  });
}

// 基础数据添加页面 上级分类下拉查询
export function qrySupplierClassifyNewLevelTwo(data) {
  return request({
    url: "/apis/demo/supplierClassifyNew/qrySupplierClassifyNewLevelTwo",
    method: "post",
    data
  });
}

// 维护资质需求
export function maintainAptitudeRequire(data) {
  return request({
    url: "/apis/demo/aptitudeFile/maintainAptitudeRequire",
    method: "post",
    data
  });
}

// 资质文件列表
export function maintainAptitudeFile(data) {
  return request({
    url: "/apis/demo/aptitudeFile/maintainAptitudeFile",
    method: "post",
    data
  });
}

// 添加删除等级
export function maintainGrade(data) {
  return request({
    url: "/apis/demo/supplierGrade/maintainGrade",
    method: "post",
    data
  });
}

// 查询等级是否已被用，被用则不能删除
export function checkDeleteRank(data) {
  return request({
    url: "/apis/demo/supplierGrade/checkDeleteRank",
    method: "post",
    data
  });
}
